import { StyleSheet } from '@react-pdf/renderer';
import { FONT } from '../../types/enums';

export const receiptA4Styles = StyleSheet.create({
  mainContainer: { paddingHorizontal: '32px', paddingVertical: '32px', paddingTop: 0 },
  mainContainer4x10: { paddingHorizontal: '15px', paddingVertical: '15px', paddingTop: 0 },
  mainContainer105x140: {
    paddingHorizontal: '15px',
    paddingTop: '5px',
    height: '102.5mm',
    display: 'flex',
    justifyContent: 'flex-start'
  },
  signatureContainer: {
    border: '1px solid gray',
    marginTop: '20px',
    borderRadius: '10px',
    padding: '11px'
  },
  signatureTitle: { flexDirection: 'row', alignSelf: 'center', fontSize: '12px', fontFamily: FONT.HELVETICA_BOLD },
  signatureLine: { padding: '40px', borderBottom: '1px solid gray' },
  orderInfoBlock: {
    borderTop: '1px dashed #8A8A8A',
    borderBottom: '1px dashed #8A8A8A',
    width: '100%',
    textAlign: 'center',
    paddingTop: '20px',
    paddingBottom: '20px'
  },
  companyInfo: {
    textAlign: 'center',
    margin: '15px 0'
  },
  paymentsSummary4x10: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    fontFamily: 'Helvetica'
  },
  paymentsSummary: {
    margin: '0 100px 5px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    fontFamily: 'Helvetica'
  },
  paymentsInfo: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    margin: '0 100px 15px',
    paddingBottom: '15px',
    borderBottom: '1px dashed #8A8A8A'
  },
  paymentsInfo4x10: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    paddingBottom: '15px',
    borderBottom: '1px dashed #8A8A8A'
  },
  payments105x140mm: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    paddingBottom: '5px',
    borderBottom: '1px dashed #8A8A8A'
  },
  paymentsLeft: {
    fontFamily: FONT.HELVETICA_BOLD,
    fontSize: 13
  },
  paymentsRight: {
    fontSize: 13
  },
  textLeft: {
    fontFamily: FONT.HELVETICA_BOLD,
    fontSize: 13,
    flexWrap: 'wrap'
  },
  textRight: {
    fontSize: 13,
    flexWrap: 'wrap'
  },
  paymentType: {
    fontSize: 13,
    border: 'none'
  },
  logo: {
    width: '190mm',
    height: '40mm',
    marginBottom: '10px',
    marginHorizontal: 'auto',
    marginTop: '32px'
  },
  logo4x10: {
    width: '100mm',
    height: '30mm',
    marginTop: '10px',
    marginBottom: '10px',
    marginHorizontal: 'auto'
  },
  logo105x140: {
    width: '100mm',
    height: '30mm',
    marginHorizontal: 'auto',
    marginTop: '10px',
    marginBottom: 0
  },
  badgeName: {
    fontFamily: 'Helvetica',
    fontSize: 13,
    marginLeft: '20px',
    width: '75%'
  },
  paymentsInfoElement: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    marginTop: '5px'
  },
  event: {
    borderTop: '1px dashed #8a8a8a',
    textAlign: 'center',
    fontSize: 13,
    paddingTop: '15px',
    paddingBottom: '15px'
  }});
